import { useEffect, useState } from 'react';

/** Used to determine if we're on the client or not. */
export default function useDevice() {
  const [isDevice, setIsDevice] = useState<{
    isMobile: boolean;
    isIOS: boolean;
  }>({
    isMobile: false,
    isIOS: false,
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const isIOS = /iPad|iPhone|iPod/i.test(
        (window as Window).navigator.userAgent,
      );
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          (window as Window).navigator.userAgent,
        );
      setIsDevice({ isMobile, isIOS });
    }
  }, []);

  return isDevice;
}
